import constant from './constant'

const dictionary = new Map([
  [constant.LOGIN_TITLE, 'ลงชื่อเข้าใช้บัญชี Finnomena'],
  [constant.REGISTER_TITLE, 'สมัครสมาชิก Finnomena เพื่อใช้ลงทุนกองทุนรวม'],
  [constant.LOGIN_LABEL_EMAIL, 'อีเมลบัญชีสมาชิก Finnomena'],
  [constant.REGISTER_ALREADY_HAS_ACCOUNT, 'เป็นสมาชิก Finnomena อยู่แล้ว?'],

  [constant.LOGIN, 'ลงชื่อเข้าใช้'],
  [constant.LOGIN_NOT_A_MEMBER, 'ยังไม่ได้เป็นสมาชิก?'],
  [constant.LOGIN_LABEL_PASSWORD, 'รหัสผ่านสมาชิก Finnomena'],
  [constant.LOGIN_BTN_NEXT, 'ต่อไป'],
  [constant.LOGIN_BTN_BACK, 'กลับ'],
  [constant.LOGIN_WITH_SOCIAL, 'ลงชื่อเข้าใช้ด้วย'],
  [constant.LOGIN_VERIFY_IDENTITY, 'กรุณายืนยันตัวตนด้วยวิธีต่อไปนี้เพื่อลงชื่อเข้าใช้'],
  [
    constant.LOGIN_HAS_ACCOUNT_VERIFY_IDENTITY,
    'อีเมลนี้เคยมีบัญชีสมาชิก Finnomena แล้ว กรุณายืนยันตัวตนด้วยในวิธีต่อไปนี้เพื่อลงชื่อเข้าใช้ และผูกบัญชี'
  ],
  [constant.LOGIN_FORGOT_PASSWORD, 'ลืมรหัสผ่าน'],
  [constant.LOGIN_ERROR, 'เกิดข้อผิดพลาด'],
  [constant.LOGIN_ERROR_INCORRECT_PASSWORD, 'รหัสผ่านไม่ถูกต้อง ต้องการ'],
  [constant.LOGIN_ERROR_ACCOUNT_LOCKED, 'บัญชีถูกล็อคเนื่องจากมีการกรอกรหัสผ่านไม่ถูกต้อง 10 ครั้งติดต่อกัน กรุณา'],
  [constant.LOGIN_ERROR_RESET_PASSWORD, 'รีเซ็ตรหัสผ่าน'],
  [constant.LOGIN_ERROR_WRONG_PASSWORD, 'รหัสผ่านไม่ถูกต้อง'],

  [constant.FORGOTPASSWORD_TITLE, 'ไม่รู้รหัสผ่าน'],
  [constant.FORGOTPASSWORD_SUB_TITLE, 'เราจะส่งลิงก์เปลี่ยนรหัสผ่านใหม่ไปทางอีเมล'],
  [constant.FORGOTPASSWORD_BTN_SEND_RESET_LINK, 'ส่งลิงก์เปลี่ยนรหัสผ่าน'],

  [constant.FORGOTPASSWORD_SENT_TITLE, 'ลิงก์เปลี่ยนรหัสผ่านถูกส่งแล้ว'],
  [constant.FORGOTPASSWORD_SENT_SUBTITLE_A, 'กรุณาตรวจสอบอีเมล'],
  [constant.FORGOTPASSWORD_SENT_SUBTITLE_B, 'สำหรับวิธีการเปลี่ยนรหัสผ่าน กรุณาเปลี่ยนรหัสผ่านภายใน 30 นาที'],
  [constant.FORGOTPASSWORD_SENT_BTN, 'กลับไปลงชื่อเข้าใช้'],

  [constant.REGISTER, 'สมัครสมาชิก'],
  [constant.REGISTER_LABEL_EMAIL, 'อีเมล'],
  [constant.REGISTER_LABEL_PASSWORD, 'รหัสผ่าน'],
  [constant.REGISTER_LABEL_PASSWORD_AGAIN, 'รหัสผ่านอีกครั้ง'],
  [constant.REGISTER_PASSWORD_MIN_LENGTH, 'ความยาวขั้นต่ำ 8 หลัก'],
  [
    constant.REGISTER_PASSWORD_CRITERIA,
    'ความยาวอย่างน้อย 8 ตัว รวมภาษาอังกฤษตัวใหญ่ ตัวเล็ก ตัวเลข และอักขระพิเศษอย่างน้อย 1 ตัว'
  ],
  [constant.REGISTER_TC_ACKNOWLEDGEMENT, 'การกดปุ่มสมัครสมาชิก แสดงว่าคุณเข้าใจและยอมรับ'],
  [constant.REGISTER_TC_TERMS_OF_USE, 'ข้อตกลงเงื่อนไขการใช้งาน'],
  [constant.REGISTER_TC_AND, 'และ'],
  [constant.REGISTER_TC_PRIVACY_POLICY, 'นโยบายความเป็นส่วนตัว'],
  [
    constant.REGISTER_TC_OPT_OUT_MSG,
    ' ของ Finnomena คุณสามารถระงับการรับข่าวสารการลงทุน และสิทธิประโยชน์ต่างๆได้ที่หน้า Profile ใน Finnomena.com'
  ],

  [constant.DIVIDER_OR, 'หรือ'],
  [constant.CONTACT_US, 'ติดต่อเรา'],
  [constant.INPUT_SHOW, 'แสดง'],
  [constant.INPUT_HIDE, 'ซ่อน'],
  [constant.EMAIL, 'อีเมล'],
  [constant.EMAIL_ALT, 'สำหรับบัญชีสมาชิก Finnomena'],
  [constant.BACK, 'กลับ'],
  [constant.BACK_HOMEPAGE, 'กลับสู่หน้าหลัก'],

  [constant.ERROR_EMAIL_REQUIED, 'กรุณากรอกอีเมล'],
  [constant.ERROR_EMAIL_INVALID, 'กรุณากรอกอีเมลให้ถูกต้อง'],
  [constant.ERROR_EMAIL_EXIST, 'อีเมลนี้มีในระบบแล้ว'],
  [constant.ERROR_EMAIL_IN_USE, 'อีเมลนี้ถูกใช้แล้ว มีปัญหาการใช้งาน?'],
  [constant.ERROR_EMAIL_NOT_MEMBER, 'อีเมลนี้ไม่เคยเป็นสมาชิก Finnomena'],
  [constant.ERROR_PASSWORD_REQUIRED, 'กรุณากรอกรหัสผ่าน'],
  [constant.ERROR_PASSWORD_MIN_LENGTH, 'ขั้นต่ำ 8 อักษร'],
  [
    constant.ERROR_PASSWORD_WRONG_PATTERN,
    'ความยาวอย่างน้อย 8 ตัว รวมภาษาอังกฤษตัวใหญ่ ตัวเล็ก ตัวเลข และอักขระพิเศษอย่างน้อย 1 ตัว'
  ],
  [constant.ERROR_PASSWORD_MISMATCH, 'รหัสผ่านไม่ตรงกัน'],
  [constant.ERROR_OCCURRED, 'เกิดข้อผิดพลาด'],
  [constant.ERROR_OCCURRED_SOCIAL, 'เกิดความผิดพลาด'],

  [constant.SUCCESS_TITLE, 'สมัครสมาชิกเรียบร้อยแล้ว'],
  [constant.SUCCESS_REDIRECT_TEXT, 'กำลังนำคุณกลับไปที่ Finnomena ใน'],
  [constant.SUCCESS_DESC_CHECK_EMAIL, 'อย่าลืมเช็คอีเมล'],
  [constant.SUCCESS_DESC_INFO, 'สำหรับข้อมูลและ'],
  [constant.SUCCESS_DESC_PRIVILEGE, 'สิทธิพิเศษสำหรับสมาชิก Finnomena'],

  [constant.EMAILSUCCESS_TITLE, 'ยืนยันอีเมลเรียบร้อย'],
  [constant.EMAILSUCCESS_SUBTITLE, 'ถูกยืนยันแล้ว'],
  [constant.EMAILSUCCESS_REDIRECT_TEXT, 'กำลังนำคุณกลับไปที่ Finnomena ใน'],
  [constant.EMAILSUCCESS_REDIRECT_LINK, 'กดที่นี่หากหน้าไม่ถูกเปลี่ยน'],

  [constant.RESETPASSWORD, 'เปลี่ยนรหัสผ่าน'],
  [constant.RESETPASSWORD_LABEL_EMAIL, 'อีเมล'],
  [constant.RESETPASSWORD_LABEL_PASSWORD, 'รหัสผ่าน'],
  [constant.RESETPASSWORD_LABEL_PASSWORD_AGAIN, 'รหัสผ่านอีกครั้ง'],
  [constant.RESETPASSWORD_LABEL_OLD_PASSWORD_DUPLICATED, 'รหัสผ่านที่กรอกตรงกับรหัสผ่านเก่าของคุณ กรุณาเลือกรหัสผ่านใหม่'], 

  [constant.RESETPASSWORD_SUCCESS_TITLE, 'เปลี่ยนรหัสผ่านเรียบร้อย'],
  [constant.RESETPASSWORD_SUCCESS_SUBTITLE_A, 'คุณสามารถลงชื่อเข้าใช้ด้วยอีเมล'],
  [constant.RESETPASSWORD_SUCCESS_SUBTITLE_B, 'ได้ทันที'],

  [constant.RESETPASSWORD_EXPIRED_SUBTITLE, 'ลิงก์เปลี่ยนรหัสผ่านนี้หมดอายุแล้ว กรุณาขอรีเซ็ตรหัสผ่านใหม่'],
  [constant.RESETPASSWORD_EXPIRED_BTN, 'ขอรีเซ็ตรหัสผ่าน'],

  [constant.INELIGIBLE_BTN, 'เปิดบัญชีกองทุนกับ Finnomena'],

  [constant.INCIDENT_TITLE, 'ไม่สามารถเข้าใช้ด้วย Facebook ได้'],
  [
    constant.INCIDENT_DESC,
    'ด้วยเหตุผลด้านความปลอดภัยของ Facebook บนมือถือ Android คุณจะเข้าใช้ผ่านบัญชี Facebook ได้ด้วยแอป Finnomena เวอร์ชันล่าสุด และมีการติดตั้งแอป Facebook ลงในเครื่องเท่านั้น'
  ],
  [constant.INCIDENT_DESC_UPDATE, 'อัปเดตแอป Finnomena และติดตั้งแอป Facebook เพื่อเข้าใช้ตามปกติ'],
  [constant.INCIDENT_OR, 'หรือ'],
  [constant.INCIDENT_REGISTER, 'สมัครสมาชิกด้วยอีเมล'],
  [constant.INCIDENT_ALREADY_HAS_ACCOUNT, 'มีบัญชีผู้ใช้ Finnomena อยู่แล้ว กรุณา'],
  [constant.INCIDENT_LOGIN, 'ลงชื่อด้วยอีเมลและรหัสผ่าน'],
  [constant.INCIDENT_FORGOT_PASSWORD, 'หากมีบัญชีผู้ใช้แต่ไม่ทราบรหัสผ่าน กรุณาตั้งรหัสผ่านใหม่ด้วยการ'],
  [constant.INCIDENT_RESET_PASSWORD, 'รีเซ็ตรหัสผ่าน']
])

export default dictionary
